export default "__VITE_ASSET__DnKHCJf3__"